import React, { useState, useEffect } from "react";
//import "./styles.css";
import { Row, Col, Button, Modal, Form } from "react-bootstrap";
import LeftpanelMember from "../../components/leftpanel/leftpanel-member";
import HeaderPart from "../../components/layout/header/header";
import LoadingOverlay from "react-loading-overlay";
import "./dashboard-member.css";
import StarAccessModal from "../../components/star-access-modal";

import {
  Banner_1,
  Shopping,
  Certificatebanner,
  TrainingVideos,
  ResourcesBanner,
  PrefferedPartners,
  AffiliateDashboard,
  tvi_star_image,
  bucks_banner_image,
  Dollar_Img,
  Plane_Img,
  CErtificates,
  cloud_download,
  Code_Redemption,
  Escape_Trips_Icon,
  Travel_Portal_Icon,
  Dream_Certificate_Icon
} from "../../assets/images";
import axios from "../../axios/axios";
import { message, Pagination, Image } from "antd";
import apiConfig from "../../config/api.config";
import { setSuccessCode } from "../../actions/signUp.actions";
import { useSelector, useDispatch } from "react-redux";
import Moment from "react-moment";
import { setEscapeBuckRedeemModal } from "../../actions/escapeBucks.actions";
import { useHistory } from "react-router-dom";
import TravelPortalModel from "../../components/TravelPortalModal";
import countryConfig from "../../config/country.config";

const DashboardPart = () => {
  const history = useHistory();
  const [user, setUser] = useState(
    localStorage.getItem("userDetails")
      ? JSON.parse(localStorage.getItem("userDetails"))
      : null
  );
  const [arriviaUserId, setArriviaUserId] = useState(
    user ? user.arriviaUserId : null
  );
  const [show, setShow] = useState(false);

  const [first, setFirst] = useState("");
  const [phone, setPhone] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [last, setLast] = useState("");
  const [arriviaLoader, setArriviaLoader] = useState(false);
  const [address, setAddress] = useState("");
  const [loadTravel, setLoadTravel] = useState("");
  const [subPackagePrice, setSubPackagePrice] = useState("");
  const [starAccessModalShow, setStarAccessModalShow] = useState(false);
  const [events, setEvents] = useState([]);
  const [arrivia_password, setArriviaPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [belongsToUserId, setBelongsToUserId] = useState(null);
  const [graphics, setGraphics] = useState([]);
  const [graphicsPage, setGraphicsPage] = useState(1);
  const [graphicsTotal, setGraphicsTotal] = useState(0);
  const [hoveredGraphic, setHoveredGraphic] = useState(null);
  const [corporateGraphicsHeadingText, setCorporateGraphicsHeadingText] = useState("");

  const successModal = useSelector((state) => state.changeStep.successCode);
  const dispatch = useDispatch();
  const starModalCose = () => {
    setStarAccessModalShow(false);
  };

  const modalClose = () => {
    setLoadTravel(false);
    setShow(false);
  };
  const getBaseURL = () => {
    switch (process.env.ENV) {
      case "STAGING":
        return process.env.REACT_APP_API_URL_STAGING;

      case "DEVELOPEMENT":
        return process.env.REACT_APP_API_URL_LOCAL;

      default:
        return process.env.REACT_APP_API_URL_STAGING;
    }
  };
  const handleFirst = (event) => {
    switch (event.target.name) {
      case "first":
        setFirst(event.target.value);
        break;
      case "last":
        setLast(event.target.value);
        break;
      case "address":
        setAddress(event.target.value);
        break;
      case "city":
        setCity(event.target.value);
        break;
      case "phone":
        setPhone(event.target.value);
        break;
      case "arrivia_password":
        setArriviaPassword(event.target.value);
        break;

      default:
        setCountry(event.target.value);
        break;
    }
  };
  const modalShow = () => setShow(true);
  const arriviaRegister = async () => {
    let isRegistered = false;
    if (!first || !phone || !city || !country || !last || !address || !arrivia_password) {
      message.warning("Please fill up the form properly");
    } else {
      if (arrivia_password.length < 8) {
        message.warning("Password should be at least 8 characters");
        return;
      }
      setArriviaLoader(true);
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
        },
      };
      let data = {
        firstName: first,
        lastName: last,
        phone,
        country,
        city,
        address,
        password: arrivia_password
      };
      await axios
        .post(`${apiConfig.api}user/arrivia_register_prife`, data, config)
        .then((res) => {
          if (res.data.status) {
            modalClose();
            setArriviaLoader(false);
            message.warning("Registering to dashboard, please wait");
            setArriviaUserId(res.data.data);
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            userDetails.arriviaUserId = res.data.data;

            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            isRegistered = true;

            let arrivi = res.data?.arriCred?.arriviaRedirectUrl
            window.open(arrivi + res.data.data, "_blank");
            // window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
          } else {
            setArriviaLoader(false);
            message.error("Something went wrong. Login failed!");
          }
        })
        .catch((err) => {
          setArriviaLoader(false);
          console.log("err", err);
          message.error(
            err.response.data.message ??
            "Something went wrong. Please try again letter"
          );
        });

      if (isRegistered) {
        modalClose();
        setArriviaLoader(false);
        message.success("User is successfully registered.");
      } else {
        setArriviaLoader(false);
      }
    }
  };
  useEffect(() => {
    if (!localStorage.getItem("AuthToken")) {
      window.open("/login", "_self");
    }
    if (user) {
      axios
        .get(`user/get-user-id-by-affiliate-details/${user.id}`)
        .then((res) => {
          if (res.data.status) {
            setSubPackagePrice(res.data.data?.belongsToUser?.packagePrice);
            setBelongsToUserId(res.data.data?.belongsToUser?._id);
            localStorage.setItem(
              "subPrice",
              res.data.data?.belongsToUser?.packagePrice
            );
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("AuthToken")}`,
      },
    };
    axios.get(`/advantage-member/client-graphics?page=${graphicsPage}&limit=3`, config)
      .then((res) => {
        setLoading(false);
        console.log(res.data.pagination?.total);
        if (res.data.status) {
          setCorporateGraphicsHeadingText(res?.data?.headingText || "");
          setGraphics(res.data.data || []);
          setGraphicsTotal(res.data.pagination?.total || 0);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("Error fetching graphics:", err);
      });
  }, [graphicsPage]);

  useEffect(() => { }, [successModal]);

  const handleModalCloseSuccess = () => {
    dispatch(setSuccessCode(false));
  };

  const arriviaLogin = async () => {
    const config = {
      headers: { Authorization: `Bearer ${localStorage.getItem("AuthToken")}` },
    };
    if (!arriviaUserId) {
      modalShow();
      return 0;
    }
    // setLoadTravel(true);
    // else message.success("Redrecting you to TravelDeals dashboard, please wait");
    message.success("Redirecting to dashboard. Please wait...");
    await axios
      .post(`${apiConfig.api}user/arrivia_login_prife`, {}, config)
      .then((res) => {
        if (res.data.status) {
          setLoadTravel(false);
          let arrivi = res.data?.arriCred?.arriviaRedirectUrl
          window.open(arrivi + res.data.data);
          // window.open(apiConfig.arriviaRedirectUrl + res.data.data, "_blank");
        } else {
          message.error("Something went wrong. Login failed!");
        }
      })
      .catch((err) => {
        setLoadTravel(false);
        message.error(
          err.response.data.message ??
          "Something went wrong. Please try again letter"
        );
      });
  };

  useEffect(() => {
    getUpcomingEvents();
  }, []);

  const getUpcomingEvents = () => {
    axios
      .post("/selected-calendar", { portal: "TripValetIncentive" })
      .then((res) => {
        if (res.data.status) {
          setEvents(res.data.data);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.log("err", err);
        message.error(
          err.response.data.message ?? "Something went wrong. Please try again"
        );
      });
  };

  return (
    <div>
      <HeaderPart userDetails={user} />
      {/* <LoadingOverlay active={false} spinner text="Loading ..."> */}
      <div className="main_cont">
        <LeftpanelMember
          arriviaLogin={() => {
            arriviaLogin();
          }}
        />
        <div className="right_cont">
          <div className="right_banner_banner_cnt">

            <Row className="g-4 justify-content-center">
              {/* Redeem Card */}
              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="action-card primary" style={{ backgroundColor: "#0f4fb6" }}>
                  <div className="icon-wrapper">
                    <div className="icon">
                      <img src={Code_Redemption} alt="" srcset="" width={100} />
                    </div>
                  </div>

                  <div className="action-box" onClick={() => {
                    dispatch(setEscapeBuckRedeemModal(true));

                  }}>
                    Redeem New Code
                  </div>
                </div>
              </Col>

              {/* Travel Portal Card */}
              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="action-card secondary" style={{ backgroundColor: "#263a6d" }}>
                  <div className="icon-wrapper">
                    <div className="icon">
                      <img src={Travel_Portal_Icon} alt="" srcset="" width={100} />
                    </div>
                  </div>

                  <div className="action-box" onClick={arriviaLogin}>
                    <div className="action-title">Sign into Travel Portal</div>
                    <div className="action-subtitle">
                      First Time Users Must Register
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="action-card secondary" style={{ backgroundColor: "#28a7e1" }}>
                  <div className="icon-wrapper">
                    <div className="icon">
                      <img src={Dream_Certificate_Icon} alt="" srcset="" width={100} />
                    </div>
                  </div>

                  <div className="action-box" onClick={() => {
                    history.push('/travel-certificates');
                  }}>
                    Send Dream Certificate
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="g-4 justify-content-center mt-4">
              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="faq-card faq-primary" onClick={() => {
                  window.open('https://tvi-api.s3.us-east-2.amazonaws.com/FAQ_Escape_Credits.pdf', '_blank')
                }}>
                  <div className="faq-icon">
                    <img src={cloud_download} width={80} alt="" srcset="" />
                  </div>
                  <div className="faq-text">Escape Credits FAQ</div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="faq-card faq-secondary" onClick={() => {
                  window.open('https://tvi-api.s3.us-east-2.amazonaws.com/TripValet_Frequently_Asked_Questions_%28FAQ%29.pdf', '_blank')
                }}>
                  <div className="faq-icon">
                    <img src={cloud_download} width={80} alt="" srcset="" />
                  </div>
                  <div className="faq-text">Travel Portal FAQ</div>
                </div>
              </Col>

              <Col xs={12} sm={6} md={4} className="mb-3">
                <div className="faq-card faq-tertiary" onClick={() => {
                  window.open('https://tvi-api.s3.amazonaws.com/VIP_Travel_Reward_FAQS_DVW_8_languages.pdf', '_blank')
                }}>
                  <div className="faq-icon">
                    <img src={cloud_download} width={80} alt="" srcset="" />
                  </div>
                  <div className="faq-text">Certificate FAQ</div>
                </div>
              </Col>
            </Row>

            {/* Gallery Section */}
            {graphics && graphics.length > 0 && (
              <LoadingOverlay active={loading} spinner text="Loading ...">
                <div className="mt-5">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h2>{corporateGraphicsHeadingText || "Escape Trips"}</h2>
                  </div>
                  <Row className="g-3">
                    {graphics.map((graphic, index) => (
                      <Col xs={12} sm={6} md={4} key={index}>
                        <div
                          className="gallery-image-wrapper"
                          style={{ cursor: graphic.link ? 'pointer' : 'default', overflow: 'hidden', borderRadius: '4px', height: '260px', position: 'relative' }}
                          onClick={() => graphic.link && window.open(graphic.link, "_blank")}
                          onMouseEnter={() => setHoveredGraphic(index)}
                          onMouseLeave={() => setHoveredGraphic(null)}
                        >
                          <Image
                            src={graphic.image}
                            alt="gallery"
                            style={{ width: '100%', height: '260px', objectFit: 'cover', display: 'block' }}
                            preview={!graphic.link}
                            className="image_block"
                          />
                          {graphic.link && (
                            <div
                              style={{
                                position: 'absolute',
                                top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                opacity: hoveredGraphic === index ? 1 : 0,
                                transition: 'opacity 0.3s',
                                zIndex: 1
                              }}
                            >
                              <span style={{ color: '#fff', fontSize: '16px' }}>Go to Link</span>
                            </div>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                  {graphicsTotal > 3 && (
                    <div className="d-flex justify-content-center mt-4 mb-3">
                      <Pagination
                        current={graphicsPage}
                        pageSize={3}
                        total={graphicsTotal}
                        onChange={(page) => setGraphicsPage(page)}
                      />
                    </div>
                  )}
                </div>
              </LoadingOverlay>
            )}


          </div>


        </div>
      </div>
      {/* </LoadingOverlay> */}
      {starAccessModalShow ? (
        <>
          <StarAccessModal
            show={starAccessModalShow}
            starModalCose={starModalCose}
          />
        </>
      ) : (
        <></>
      )}
      <LoadingOverlay active={loadTravel} spinner text="Redirecting to TravelDeals Dashboard...Please wait.."></LoadingOverlay>
      <TravelPortalModel
        show={show}
        modalClose={modalClose}
        first={first}
        last={last}
        phone={phone}
        address={address}
        city={city}
        country={country}
        arrivia_password={arrivia_password}
        arriviaLoader={arriviaLoader}
        handleFirst={handleFirst}
        countryConfig={countryConfig}
        arriviaRegister={arriviaRegister}
      />
      <Modal show={successModal} onHide={handleModalCloseSuccess}>
        <Modal.Body>
          <div className="modal_close">
            <h2 className="text-center">Congratulations!</h2>
            <h3>You have successfully updated your new membership plan.</h3>
            <Button
              variant="secondary"
              onClick={handleModalCloseSuccess}
              className="close_buuut"
            ></Button>
          </div>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default DashboardPart;
